__turbopack_context__.v({
  "button": "Button-module__8RiFmG__button",
  "primary": "Button-module__8RiFmG__primary",
  "secondary": "Button-module__8RiFmG__secondary",
});
